import { LinkIconPlacement as CKLinkIconPlacement } from '@property.com.au/ui-kit';

export type LinkIconPlacement = 'LEFT' | 'RIGHT' | 'left' | 'right';

export const mapLinkIconPlacement = (
  placement: LinkIconPlacement | null | undefined,
): CKLinkIconPlacement => {
  switch (placement) {
    case 'RIGHT':
    case 'right':
      return 'right';
    case 'LEFT':
    case 'left':
    default:
      return 'left';
  }
};
